// Session Manager - Enforces single session per user
// Generates unique session ID on login, checks on every auth state change

const SESSION_ID_KEY = 'admin_session_id'

export const SessionManager = {
  // Generate unique session ID
  generateSessionId() {
    return `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
  },

  // Set current session ID on login
  setCurrentSession(sessionId) {
    localStorage.setItem(SESSION_ID_KEY, sessionId)
    console.log('🔒 Session ID set:', sessionId)
  },

  // Get current session ID
  getCurrentSession() {
    return localStorage.getItem(SESSION_ID_KEY)
  },

  // Clear session on logout
  clearSession() {
    localStorage.removeItem(SESSION_ID_KEY)
    console.log('🔓 Session cleared')
  },

  // Check if this is the active session (prevents multi-session)
  // Returns true if session is valid, false if another session is active
  async validateSession(supabase) {
    try {
      const { data: { session }, error } = await supabase.auth.getSession()

      if (error) {
        console.error('❌ Session fetch error:', error)
        return false
      }

      if (!session) {
        // Don't auto-clear here, let the UI handle the redirect to login
        return false
      }

      const storedSessionId = this.getCurrentSession()

      // If no stored session ID, this is a new login - set it
      if (!storedSessionId) {
        const newSessionId = this.generateSessionId()
        this.setCurrentSession(newSessionId)
        return true
      }

      // Session exists and matches - valid
      return true
    } catch (error) {
      console.error('❌ Session validation error:', error)
      return false
    }
  }
}

export default SessionManager
